import { useTranslation } from 'react-i18next'
import { PageHeader } from '@/components/sections/PageHeader'
import { PageMeta } from '@/components/PageMeta'
import { Shield } from 'lucide-react'

export function PrivacyPolicyPage() {
  const { t } = useTranslation('pages')

  return (
    <>
      <PageMeta title={`${t('privacy.title')} — FG Automazioni`} description={t('privacy.subtitle')} />
      <PageHeader
        title={t('privacy.title')}
        subtitle={t('privacy.subtitle')}
        tag={t('privacy.tag')}
        icon={Shield}
        gradient="slate"
      />

      <section className="bg-white py-16 md:py-24">
        <div className="mx-auto max-w-4xl px-4 lg:px-8">
          <div className="prose prose-lg max-w-none prose-headings:text-slate-900 prose-p:text-slate-600">
            {/* Introduzione */}
            <div className="mb-12">
              <h2 className="text-2xl font-bold text-slate-900 mb-4">{t('privacy.introTitle')}</h2>
              <p className="text-slate-600 leading-relaxed">{t('privacy.introText')}</p>
            </div>

            {/* Titolare del trattamento */}
            <div className="mb-12 rounded-2xl bg-slate-50 p-8">
              <h3 className="text-xl font-semibold text-slate-900 mb-4">{t('privacy.controllerTitle')}</h3>
              <div className="space-y-2 text-slate-600">
                <p className="font-medium text-slate-900">FG Automazioni S.r.l.</p>
                <p>{t('privacy.controllerAddress')}</p>
                <p>P.IVA: 01088580937</p>
                <p>{t('privacy.controllerEmail')}: info@fgautomazioni.it</p>
                <p>{t('privacy.controllerPhone')}: +39 0434 994636</p>
              </div>
            </div>

            {/* Dati raccolti */}
            <div className="mb-12">
              <h3 className="text-xl font-semibold text-slate-900 mb-4">{t('privacy.dataCollectedTitle')}</h3>
              <p className="text-slate-600 mb-4">{t('privacy.dataCollectedText')}</p>
              <ul className="list-disc pl-6 space-y-2 text-slate-600">
                <li>{t('privacy.dataCollected.item1')}</li>
                <li>{t('privacy.dataCollected.item2')}</li>
                <li>{t('privacy.dataCollected.item3')}</li>
                <li>{t('privacy.dataCollected.item4')}</li>
              </ul>
            </div>

            {/* Finalità */}
            <div className="mb-12">
              <h3 className="text-xl font-semibold text-slate-900 mb-4">{t('privacy.purposesTitle')}</h3>
              <p className="text-slate-600 mb-4">{t('privacy.purposesText')}</p>
              <ul className="list-disc pl-6 space-y-2 text-slate-600">
                <li>{t('privacy.purposes.item1')}</li>
                <li>{t('privacy.purposes.item2')}</li>
                <li>{t('privacy.purposes.item3')}</li>
                <li>{t('privacy.purposes.item4')}</li>
              </ul>
            </div>

            {/* Base giuridica */}
            <div className="mb-12">
              <h3 className="text-xl font-semibold text-slate-900 mb-4">{t('privacy.legalBasisTitle')}</h3>
              <p className="text-slate-600">{t('privacy.legalBasisText')}</p>
            </div>

            {/* Conservazione */}
            <div className="mb-12">
              <h3 className="text-xl font-semibold text-slate-900 mb-4">{t('privacy.retentionTitle')}</h3>
              <p className="text-slate-600">{t('privacy.retentionText')}</p>
            </div>

            {/* Diritti dell'interessato */}
            <div className="mb-12">
              <h3 className="text-xl font-semibold text-slate-900 mb-4">{t('privacy.rightsTitle')}</h3>
              <p className="text-slate-600 mb-4">{t('privacy.rightsText')}</p>
              <ul className="list-disc pl-6 space-y-2 text-slate-600">
                <li>{t('privacy.rights.item1')}</li>
                <li>{t('privacy.rights.item2')}</li>
                <li>{t('privacy.rights.item3')}</li>
                <li>{t('privacy.rights.item4')}</li>
                <li>{t('privacy.rights.item5')}</li>
                <li>{t('privacy.rights.item6')}</li>
              </ul>
              <p className="text-slate-600 mt-4">{t('privacy.rightsContact')}</p>
            </div>

            {/* Sicurezza */}
            <div className="mb-12">
              <h3 className="text-xl font-semibold text-slate-900 mb-4">{t('privacy.securityTitle')}</h3>
              <p className="text-slate-600">{t('privacy.securityText')}</p>
            </div>

            {/* Modifiche */}
            <div className="mb-12">
              <h3 className="text-xl font-semibold text-slate-900 mb-4">{t('privacy.changesTitle')}</h3>
              <p className="text-slate-600">{t('privacy.changesText')}</p>
            </div>

            {/* Data aggiornamento */}
            <div className="pt-8 border-t border-slate-200">
              <p className="text-sm text-slate-500">{t('privacy.lastUpdated')}: 01/04/2026</p>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
